// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"84d4fec5","57":"18707c5d","124":"f1a59958","353":"c4b88628","449":"fa8c4f98","453":"db74b6f0","660":"dff304d2","697":"1dec0a87","712":"83d4c42d","819":"b41b6b63"}[chunkId] + ".chunk.js";
};